// Animações da Luteria Fagundes. Marque elementos com:
//   data-anim="sobe|surge|filete|cortina|zoom|gaveta|fab"
//   data-anim-filhos="sobe"          → anima os filhos em sequência
//   data-anim-atraso="200"           → atraso em ms
//   data-anim-gatilho="carga"        → toca ao carregar (padrão: ao entrar na tela)
(function () {
  if (window.LFAnim) return;
  const EASE = 'cubic-bezier(.16,1,.3,1)';
  const K = {
    sobe: [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'none' }],
    surge: [{ opacity: 0 }, { opacity: 1 }],
    filete: [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
    cortina: [{ clipPath: 'inset(0 -80px 100% -80px)' }, { clipPath: 'inset(-80px -80px -80px -80px)' }],
    zoom: [{ transform: 'scale(1.1)' }, { transform: 'none' }],
    gaveta: [{ transform: 'translateX(-100%)' }, { transform: 'none' }],
    gavetaDir: [{ transform: 'translateX(100%)' }, { transform: 'none' }],
    fab: [{ opacity: 0, transform: 'scale(.6)' }, { opacity: 1, transform: 'none' }],
    fundo: [{ transform: 'scale(1.12)' }, { transform: 'none' }],
    recorte: [{ opacity: 0, transform: 'translateX(-50%) translateY(18%)' }, { opacity: 1, transform: 'translateX(-50%)' }],
    kenburns: [{ transform: 'scale(1.3) translateY(5%)', filter: 'brightness(.55) sepia(.25)' }, { transform: 'scale(1.06)', filter: 'none' }],
    brilho: [{ opacity: 0, transform: 'translateX(-120%) skewX(-12deg)' }, { opacity: 1, transform: 'translateX(60%) skewX(-12deg)', offset: .5 }, { opacity: 0, transform: 'translateX(260%) skewX(-12deg)' }]
  };
  const DUR = { sobe: 900, surge: 900, filete: 1000, cortina: 1300, zoom: 3200, gaveta: 800, gavetaDir: 700, fab: 600, fundo: 2400, recorte: 1500, kenburns: 2600, brilho: 1600 };
  let io = null, mo = null, timer = null, debounce = null, ligado = false;
  let feitos = new WeakSet();           // elementos já tratados
  const pendentes = new Map();          // elemento → animação pausada (escondendo)
  const criadas = new Set();            // todas as animações criadas por este script
  const pulsos = [];
  const reduz = () => !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function visuais(el) {
    const out = [];
    for (const c of el.children) {
      if (c.hasAttribute('data-clone')) continue;
      const d = getComputedStyle(c).display;
      if (d === 'contents') out.push(...visuais(c)); else if (d !== 'none') out.push(c);
    }
    return out;
  }

  function animar(el, kf, opts) {
    try { const a = el.animate(kf, opts); criadas.add(a); return a; } catch (_) { return null; }
  }

  function tocar(el) {
    const a = pendentes.get(el);
    if (!a) return;
    pendentes.delete(el);
    if (io) io.unobserve(el);
    try { a.play(); } catch (_) {}
  }

  function criar(el, tipo, atraso, gatilho) {
    if (!K[tipo] || feitos.has(el)) return;
    feitos.add(el);
    if (tipo === 'filete') el.style.transformOrigin = 'left center';
    const a = animar(el, K[tipo], { duration: DUR[tipo], easing: tipo === 'brilho' ? 'ease-in-out' : EASE, delay: tipo === 'brilho' ? atraso + 1300 : atraso, fill: 'both' });
    if (!a) return;
    a.onfinish = () => { try { a.cancel(); } catch (_) {} criadas.delete(a); if (tipo === 'fab' && ligado) pulsar(el); if (tipo === 'kenburns' && ligado) deriva(el); if (el.dataset.animVivo && ligado) vivo(el, tipo); };
    if (gatilho === 'carga') return;    // toca já
    a.pause();
    pendentes.set(el, a);
    if (io) io.observe(el);
  }

  // Movimento constante e sutil depois da entrada (data-anim-vivo)
  function vivo(el, tipo) {
    if (reduz()) return;
    const kf = tipo === 'recorte'
      ? [{ transform: 'translateX(-50%) translateY(0) scale(1)' }, { transform: 'translateX(-50%) translateY(-1.6%) scale(1.02)' }]
      : [{ transform: 'scale(1) translate(0,0)' }, { transform: 'scale(1.07) translate(1.5%,-1%)' }];
    const p = animar(el, kf, { duration: tipo === 'recorte' ? 4200 : 11000, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
    if (p) pulsos.push(p);
  }

  function deriva(el) {
    const p = animar(el, [{ transform: 'scale(1.06) translate(0,0)' }, { transform: 'scale(1.12) translate(-2.5%,-1.5%)' }], { duration: 9000, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
    if (p) pulsos.push(p);
  }

  function pulsar(el) {
    const b = getComputedStyle(el).boxShadow;
    const base = b && b !== 'none' ? ',' + b : '';
    const cor = el.dataset.pulsoCor || '95,115,85';
    const p = animar(el, [
      { boxShadow: '0 0 0 0 rgba(' + cor + ',.5)' + base, offset: 0 },
      { boxShadow: '0 0 0 16px rgba(' + cor + ',0)' + base, offset: .3 },
      { boxShadow: '0 0 0 16px rgba(' + cor + ',0)' + base, offset: 1 }
    ], { duration: 5000, iterations: Infinity, easing: 'ease-out' });
    if (p) pulsos.push(p);
  }

  let letreiros = new WeakSet();
  function letreiro(el) {
    if (letreiros.has(el) || !el.isConnected) return;
    const w = el.scrollWidth / 2;
    if (!w) return;
    letreiros.add(el);
    const dir = el.dataset.letreiro === 'dir';
    const vel = Number(el.dataset.letreiroVel || 32);
    const p = animar(el, dir ? [{ transform: 'translateX(-' + w + 'px)' }, { transform: 'translateX(0)' }] : [{ transform: 'translateX(0)' }, { transform: 'translateX(-' + w + 'px)' }], { duration: w / vel * 1000, iterations: Infinity, easing: 'linear' });
    if (!p) return;
    pulsos.push(p);
    const alvo = el.parentElement || el;
    alvo.addEventListener('pointerenter', () => { try { p.pause(); } catch (_) {} });
    alvo.addEventListener('pointerleave', () => { try { p.play(); } catch (_) {} });
  }

  function varrer() {
    if (!ligado) return;
    document.querySelectorAll('[data-letreiro]').forEach(letreiro);
    document.querySelectorAll('[data-anim]').forEach(el =>
      criar(el, el.dataset.anim, Number(el.dataset.animAtraso || 0), el.dataset.animGatilho));
    document.querySelectorAll('[data-anim-filhos]').forEach(c => {
      const base = Number(c.dataset.animAtraso || 0);
      visuais(c).forEach((ch, i) => criar(ch, c.dataset.animFilhos, base + Math.min(i, 4) * 90, c.dataset.animGatilho));
    });
  }

  // Rede de segurança: toca tudo que está na tela, mesmo se o observer falhar,
  // e solta elementos que saíram do documento.
  function conferir() {
    const vh = window.innerHeight, vw = window.innerWidth;
    pendentes.forEach((a, el) => {
      if (!el.isConnected) { pendentes.delete(el); return; }
      const r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw) tocar(el);
    });
  }

  window.LFAnim = {
    iniciar() {
      if (ligado || reduz()) return;
      ligado = true;
      io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) tocar(e.target);
      }), { threshold: .12, rootMargin: '0px 0px -6% 0px' }) : null;
      mo = new MutationObserver(() => { clearTimeout(debounce); debounce = setTimeout(varrer, 80); });
      mo.observe(document.body, { childList: true, subtree: true });
      timer = setInterval(conferir, 600);
      varrer();
    },
    parar() {
      ligado = false;
      if (io) io.disconnect(); if (mo) mo.disconnect();
      clearInterval(timer); clearTimeout(debounce);
      criadas.forEach(a => { try { a.cancel(); } catch (_) {} });
      criadas.clear(); pendentes.clear();
      pulsos.splice(0).forEach(p => { try { p.cancel(); } catch (_) {} });
      feitos = new WeakSet(); letreiros = new WeakSet();
    },
    // Reanima os filhos de um contêiner na hora (troca de aba)
    entrar(c) {
      if (!ligado || !c) return;
      visuais(c).forEach((ch, i) => {
        const p = pendentes.get(ch);
        if (p) { pendentes.delete(ch); try { p.cancel(); } catch (_) {} }
        feitos.add(ch);
        animar(ch, K.sobe, { duration: 600, easing: EASE, delay: Math.min(i, 4) * 70, fill: 'backwards' });
      });
    },
    ativo: () => ligado
  };
})();

(function(){var go=function(){if(window.LFAnim)window.LFAnim.iniciar();};if(document.readyState!=="loading")go();else document.addEventListener("DOMContentLoaded",go);})();
